import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Vehicle road worthy checks stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_ROAD_WORTHY_CHECK)
export class VehicleRoadWorthyChecksStatsDto extends BaseStatsDto {
  pending!: number;
  approved!: number;
  rejected!: number;
  scheduled!: number;
  inProgress!: number;
  paid!: number;
  expired!: number;
}
